import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const CardWarpper = styled(Card)(() => ({
    borderRadius: "16px",
}));

export default CardWarpper;
